// extracted by css-extract-rspack-plugin
export default {"modal":"modal-SSI_Ua","modalHeader":"modalHeader-PTrHlc","modalContent":"modalContent-fKzTOI","modalText":"modalText-s2klMi"};